import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import UserLoginForm from '../account/userLogin';
import { isAuthenticated } from '../../services/account.service';

const AuthAwareLogin = () => {
  const [isAuth, setIsAuth] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const authStatus = isAuthenticated();
      setIsAuth(authStatus);
      setLoading(false);
    };
    checkAuth();
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (isAuth) {
    return <Navigate to="/" replace />;
  }

  return <UserLoginForm />;
};

export default AuthAwareLogin;

